import {
    GET_JOB_PACK,
    GET_NEW_JOB_PACK_UID,
    SET_JOB_PACK,
    SUBMIT_JOB_TYPE,
    GET_JOB_TYPES,
    GET_ALL_USERS,
    GET_ALL_QUALIFICATIONS,
    GET_ALL_TOOLBOXES,
    SET_JOB_TYPE,
    GET_TOTAL,
    SET_JOB_PACK_COUNT
} from "./types";
import firebase from "firebase/app";
import removeKeys from "./removeKeys";
import moment from "moment";
export const getJobPack = (
    uid = false,
    status = false,
    year = false,
    month = false
) => {
    return (dispatch) => {
        dispatch({ type: GET_JOB_PACK.REQUEST });
        if (uid && status) {
            try {
                firebase.auth().onAuthStateChanged((user) => {
                    if (user) {
                        firebase
                            .database()
                            .ref(
                                `/subjects/jobpacks/${status}/${year}/${month}/${uid}`
                            )
                            .on("value", (snapshot) => {
                                dispatch({
                                    type: GET_JOB_PACK.SUCCESS,
                                    payload: snapshot.val(),
                                });
                            });
                    } else {
                        dispatch({ type: GET_JOB_PACK.FAIL });
                    }
                });
            } catch {
                dispatch({ type: GET_JOB_PACK.FAIL });
            }
        } else {
            return dispatch({ type: GET_JOB_PACK.FAIL });
        }
    };
};
export const getToolboxTalks = () => {
    return (dispatch) => {
        dispatch({ type: GET_ALL_TOOLBOXES.REQUEST });

        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/subjects/toolbox`)
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_ALL_TOOLBOXES.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                } else {
                    dispatch({ type: GET_ALL_TOOLBOXES.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_ALL_TOOLBOXES.FAIL });
        }
    };
};
export const getAllQualifications = () => {
    return (dispatch) => {
        dispatch({ type: GET_ALL_QUALIFICATIONS.REQUEST });

        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                firebase
                    .database()
                    .ref(`collections/qualifications`)
                    .on(
                        "value",
                        (snapshot) => {
                            dispatch({
                                type: GET_ALL_QUALIFICATIONS.SUCCESS,
                                payload: snapshot.val(),
                            });
                        },
                        () => dispatch({ type: GET_ALL_QUALIFICATIONS.FAIL })
                    );
            } else {
                dispatch({ type: GET_ALL_QUALIFICATIONS.FAIL });
            }
        });
    };
};
export const getJobTypes = () => {
    return (dispatch) => {
        dispatch({ type: GET_JOB_TYPES.REQUEST });

        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/subjects/job_pack_templates`)
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_JOB_TYPES.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                } else {
                    dispatch({ type: GET_JOB_TYPES.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_JOB_TYPES.FAIL });
        }
    };
};
export const getNewJobPackID = () => {
    return async (dispatch) => {
        dispatch({ type: GET_NEW_JOB_PACK_UID.REQUEST });

        let newJobPackID = Date.now().toString();

        dispatch({
            type: GET_NEW_JOB_PACK_UID.SUCCESS,
            payload: newJobPackID,
        });
    };
};
export const getNewJobTypeID = async () => {
    let jobTypes = await getAllJobPackTypes();
    let newJobTypeID;
    if (jobTypes) {
        let jobTypeIDs = Object.keys(jobTypes).map((e) => e);
        jobTypeIDs = jobTypeIDs.sort().reverse();
        newJobTypeID = (Number(jobTypeIDs[0]) + 1).toString().padStart(6, "0");
        return newJobTypeID;
    } else if (jobTypes == null) {
        return "000001";
    } else return false;
};

export const getAllJobPacks = async () => {
    let user = await firebase.auth().onAuthStateChanged(async (user) => {
        return user;
    });
    if (user) {
        let active = await firebase
            .database()
            .ref(`/subjects/job_packs/`)
            .once("value");
        active = active.val();

        let pending = await firebase
            .database()
            .ref(`/subjects/job_pending/`)
            .once("value");
        pending = pending.val();
        let archived = await firebase
            .database()
            .ref(`/subjects/job_archived/`)
            .once("value");
        archived = archived.val();
        return { ...active, ...pending, ...archived };
    } else {
        return false;
    }
};

export const getAllJobPackTypes = async () => {
    let user = await firebase.auth().onAuthStateChanged((user) => {
        return user;
    });
    if (user) {
        let snapshot = await firebase
            .database()
            .ref(`/subjects/job_pack_templates/`)
            .once("value");
        return snapshot.val();
    } else {
        return false;
    }
};
export const setJobType = (type = "new_job_pack") => {
    return (dispatch) => {
        dispatch({ type: SET_JOB_TYPE, payload: type });
    };
};
export const setJobPack = (
    status = false,
    jobPack = false,
    blankProfile,
    pageType,
    year,
    month,
    callback
) => {
    return (dispatch) => {
        dispatch({ type: SET_JOB_PACK.REQUEST });
        if (jobPack) {
            if (!jobPack["timestamp"])
                jobPack["timestamp"] = moment().format("DD-MM-YYYY HH:mm:ss");

            //Check that all values have been filled to prevent undefined
            Object.keys(blankProfile).map((e) => {
                if (jobPack[e] === "" && e !== "sswp_config_uid") {
                    jobPack[e] = "";
                }
                return true;
            });

            firebase.auth().onAuthStateChanged(async (user) => {
                if (user) {
                    if (pageType === "create") {
                        await firebase
                            .storage()
                            .ref(
                                `/job_pack/${jobPack.job_id}/qrcode_${jobPack.job_id}.png`
                            )
                            .putString(jobPack.qr_code_url, "data_url")
                            .then(async (snapshot) => {
                                await snapshot.ref
                                    .getDownloadURL()
                                    .then((url) => {
                                        jobPack.qr_code_url = url;
                                    });
                            });
                    }
                    firebase
                        .database()
                        .ref(
                            `/subjects/jobpacks/${status}/${year}/${month}/${jobPack.job_id}`
                        )
                        .update({ profile: jobPack })
                        .then(() => {
                            dispatch({ type: SET_JOB_PACK.SUCCESS });
                            callback(true);
                        });
                } else {
                    dispatch({ type: SET_JOB_PACK.FAIL });
                    callback(false);
                }
            });
        } else {
            dispatch({ type: SET_JOB_PACK.FAIL });
            callback(false);
        }
    };
};

export const setJobPackNew = (
    status = false,
    jobPack = false,
    blankProfile,
    pageType,
    year,
    month,
    callback
) => {
    console.log(month,"month")
    return (dispatch) => {
        dispatch({ type: SET_JOB_PACK.REQUEST });
        if (jobPack) {
            jobPack["timestamp"] = moment().format("DD-MM-YYYY HH:mm:ss");

            //Check that all values have been filled to prevent undefined
            Object.keys(blankProfile).map((e) => {
                if (jobPack[e] === "" && e !== "sswp_config_uid") {
                    jobPack[e] = "";
                }
                return true;
            });

            firebase.auth().onAuthStateChanged(async (user) => {
                if (user) {
                    if (pageType === "create") {
                        await firebase
                            .storage()
                            .ref(
                                `/job_pack/${jobPack.job_id}/qrcode_${jobPack.job_id}.png`
                            )
                            .putString(jobPack.qr_code_url, "data_url")
                            .then(async (snapshot) => {
                                await snapshot.ref
                                    .getDownloadURL()
                                    .then((url) => {
                                        jobPack.qr_code_url = url;
                                    });
                            });
                    }
                    firebase
                        .database()
                        .ref(
                            `/subjects/jobpacks/${status}/${year}/${month}/${jobPack.job_id}`
                        )
                        .update({ profile: jobPack })
                        .then(() => {
                            dispatch({ type: SET_JOB_PACK.SUCCESS });
                            callback(true);
                        });
                } else {
                    dispatch({ type: SET_JOB_PACK.FAIL });
                    callback(false);
                }
            });
        } else {
            dispatch({ type: SET_JOB_PACK.FAIL });
            callback(false);
        }
    };
};
export const setEventUpdates = (posting = false, callback) => {
    return (dispatch) => {
        dispatch({ type: SET_JOB_PACK.REQUEST });
        if (posting) {
            firebase.auth().onAuthStateChanged(async (user) => {
                if (user) {
                    firebase
                        .database()
                        .ref(
                            `/subjects/week_planner/events/${posting.event_id}`
                        )
                        .update(posting)
                        .then(() => {
                            dispatch({ type: SET_JOB_PACK.SUCCESS });
                            callback(true);
                        });
                } else {
                    dispatch({ type: SET_JOB_PACK.FAIL });
                    callback(false);
                }
            });
        } else {
            dispatch({ type: SET_JOB_PACK.FAIL });
            callback(false);
        }
    };
};
export const setJobPackCount = (count) => {
    return (dispatch) => {
        dispatch({ type: SET_JOB_PACK_COUNT.REQUEST });
        firebase.auth().onAuthStateChanged((user => {
            if(user) {
                firebase
                    .database()
                    .ref("/subjects/jobpacks/")
                    .update({jobpack_count:count})
            }
            else {
                dispatch({ type: SET_JOB_PACK_COUNT.FAIL });
            }
         }))
    }
}
export const getTotalJobPackCount = () => {
    return (dispatch) => {
        dispatch({ type: GET_TOTAL.REQUEST });

        try{
            firebase.auth().onAuthStateChanged((user => {
                if(user) {
                    firebase    
                        .database()
                        .ref("/subjects/jobpacks/jobpack_count")
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_TOTAL.SUCCESS,
                                payload: snapshot.val()
                            })
                        })
                }
                else {
                    dispatch({ type: GET_ALL_USERS.FAIL });
                }
            }))
        }
        catch {
            dispatch({ type: GET_ALL_USERS.FAIL });
        }
    }

}
export const getUsers = () => {
    return (dispatch) => {
        dispatch({ type: GET_ALL_USERS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/users/`)
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_ALL_USERS.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                } else {
                    dispatch({ type: GET_ALL_USERS.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_ALL_USERS.FAIL });
        }
    };
};
export const createJobType = (
    jobType = false,
    jobTypeTitle,
    rules,
    callback,
    edit,
    updateID
) => {
    return async (dispatch) => {
        dispatch({ type: SUBMIT_JOB_TYPE.REQUEST });
        if (jobType) {
            let id = edit ? updateID : await getNewJobTypeID();
            //Check that all values have been filled to prevent undefined
            Object.keys(removeKeys).map((key) => {
                jobType[key] = null;
                return null;
            });
            firebase.auth().onAuthStateChanged((user) => {
                if (user && rules) {
                    firebase
                        .database()
                        .ref(`/subjects/job_pack_templates/${id}`)
                        .update({
                            title: jobTypeTitle,
                            profile: jobType,
                            rules,
                        })
                        .then(() => {
                            dispatch({ type: SUBMIT_JOB_TYPE.SUCCESS });
                            callback(true);
                        });
                } 
                else if(user) {
                    firebase
                        .database()
                        .ref(`/subjects/job_pack_templates/${id}`)
                        .update({
                            title: jobTypeTitle,
                            profile: jobType
                        })
                        .then(() => {
                            dispatch({ type: SUBMIT_JOB_TYPE.SUCCESS });
                            callback(true);
                        });
                }
                else {
                    dispatch({ type: SUBMIT_JOB_TYPE.FAIL });
                    callback(false);
                }
            });
        } else {
            dispatch({ type: SUBMIT_JOB_TYPE.FAIL });
            callback(false);
        }
    };
};
